export const vi = {
    'common': {
        'warn': 'Nhắc nhở', 
        'success': 'Thành công', 
        'ok': 'Đồng ý', 
        'cancle': 'Hủy bỏ', 
        'modify': 'Chỉnh sửa', 
        'delete': 'Xóa', 
        'error': 'Lỗi thông tin', 
        'loading': 'Đang tải...', 
        'your-position': 'Vị trí của bạn:', 
        'home-page': 'Trang chủ', 
        'search': 'Tìm kiếm', 
        'clear': 'Xóa', 
        'fold': 'Gấp', 
        'search-advanced': 'Tìm kiếm nâng cao', 
        'export-excel': 'Xuất Excel', 
        'print-pdf': 'In', 
        'unfold': 'Mở rộng', 
        'fold-all': 'Thu gọn tất cả', 
        'unfold-all': 'Mở rộng tất cả', 
        'collapse': 'Thu gọn', 
        'authentication-error': 'Lỗi quyền', 
        'request-error': 'Yêu cầu bị lỗi', 
        'start-date': 'Ngày bắt đầu', 
        'end-date': 'Ngày kết thúc', 
        'sort': 'Sắp xếp', 
        'asc': 'Tăng dần', 
        'desc': 'Giảm dần', 
        'no-data': 'Không có dữ liệu phù hợp', 
        'unknown-error': 'Lỗi không xác định', 
        'setup-column': 'Cấu hình danh sách', 
        'setup-save': 'Lưu cấu hình', 
        'setup-width': 'Chiều rộng cột', 
        'purchase-type': 'Tính chất đơn hàng', 
        'purchase-date': 'Ngày đặt hàng', 
        'unfold-detail': 'Hiển thị chi tiết', 
        'fold-detail': 'Ẩn chi tiết', 
        'download': 'Tải xuống', 
        'submit': 'Gửi', 
        'back': 'Quay lại', 
        'extension': 'Trường mở rộng', 
        'operate': 'Hoạt động', 
        'edit': 'Chỉnh sửa', 
        'please-select': 'Vui lòng chọn', 
        'none-data': 'Không có dữ liệu', 
        'print': 'In', 
        'all': 'Tất cả', 
        'save': 'Lưu', 
        '备注': 'Ghi chú', 
        'inquiry-publicly': 'Yêu cầu giá công khai', 
        'supplier-registration': 'Đăng ký nhà cung cấp', 
        'contact-us': 'Liên hệ với chúng tôi', 
        'name-tip': 'Vui lòng nhập tên người dùng!', 
        'no-name': 'Tên người dùng không tồn tại!', 
        'email-tip': 'Vui lòng nhập email!', 
        'email-error': 'Định dạng email không hợp lệ!', 
        'account-login': 'Đăng nhập tài khoản', 
        'forget-password': 'Quên mật khẩu', 
        'enter-account': 'Nhập tài khoản', 
        'enter-password': 'Nhập mật khẩu', 
        'password-length': 'Độ dài mật khẩu nên từ 1-16 ký tự', 
        'password-old': 'Mật khẩu mới và mật khẩu cũ không thay đổi', 
        'password-again': 'Vui lòng nhập lại mật khẩu', 
        'password-different': 'Mật khẩu nhập lại không khớp', 
        'account': 'Tài khoản', 
        'code': 'Mã xác nhận', 
        'enter-code': 'Vui lòng nhập mã xác nhận', 
        'code-tip': 'Mã xác nhận gồm 6 chữ số', 
        'enter-pwd': 'Vui lòng nhập mật khẩu mới', 
        'pwd-tip': 'Độ dài mật khẩu nên từ 1-16 ký tự', 
        'pwd-again': 'Vui lòng nhập lại mật khẩu mới', 
        'pwd-different': 'Mật khẩu nhập lại không khớp' 
 
 
    }, 
    'user': { 
        'user-center': 'Trung tâm người dùng', 
        'modify-password': 'Thay đổi mật khẩu', 
        'modify-info': 'Chỉnh sửa thông tin', 
        'modify-password-success': 'Thay đổi mật khẩu thành công', 
        'modify-info-success': 'Chỉnh sửa thông tin người dùng thành công', 
        'email-wrong-format': 'Định dạng email không chính xác!', 
        'phone-wrong-format': 'Định dạng điện thoại không chính xác!', 
        'mobile-wrong-format': 'Định dạng di động không chính xác!', 
        'userInfo': 'Thông tin người dùng', 
        'no': 'Mã số công nhân', 
        'noInfo': 'Mã số công nhân là thông tin bắt buộc', 
        'nameRequired': 'Tên là thông tin bắt buộc', 
        'emailRequired': 'Email là thông tin bắt buộc', 
        'name': 'Tên', 
        'loginName': 'Tên đăng nhập', 
        'loginNameInfo1': 'Tên đăng nhập này đã được đăng ký!', 
        'loginNameInfo2': 'Tên đăng nhập là thông tin bắt buộc!', 
        'loginNameInfo3': 'Tên đăng nhập chỉ có thể là chữ cái, số và dấu gạch dưới!', 
        'loginNameInfo4': 'Tên đăng nhập phải có ít nhất bốn ký tự!', 
        'loginNameInfo5': 'Độ dài tối đa không được vượt quá 50 ký tự!', 
        'newPassword': 'Mật khẩu', 
        'passwordInfo': 'Nếu không thay đổi, vui lòng để trống', 
        'newPasswordInfo1': 'Mật khẩu không được để trống!', 
        'newPasswordInfo2': 'Mật khẩu phải có ít nhất ba ký tự!', 
        'confirmNewPassword': 'Xác nhận mật khẩu',
        'confirmNewPasswordInfo': 'Mật khẩu nhập lại không khớp!', 
        'ent': 'Mã doanh nghiệp mặc định', 
        'entInfo': 'Mã doanh nghiệp không được để trống!', 
        'loginFlag': 'Cho phép đăng nhập', 
        'loginFlag1': 'Cho phép', 
        'loginFlag2': 'Không cho phép', 
        'userAuthority': 'Quyền người dùng', 
        'userRole': 'Vai trò người dùng', 
        'userRoleInfo': 'Nếu thay đổi vai trò của chính mình, sau khi thực hiện xong cần đăng nhập lại', 
        'nzTitle': 'Không bắt buộc (nhấn để mở rộng)', 
        'email': 'Hộp thư', 
        'phone': 'Điện thoại', 
        'mobile': 'Điện thoại di động', 
        'site': 'Địa điểm', 
        'defaultSite': 'Địa điểm mặc định', 
        'employeeNo': 'Mã số người dùng ERP', 
        'employeeName': 'Tên nhân viên ERP', 
        'departmentNo': 'Mã phòng ban', 
        'departmentName': 'Tên phòng ban ERP', 
        'ware': 'Kho mặc định', 
        'remarks': 'Ghi chú', 
        'userList': 'Danh sách người dùng', 
        'userAdd': 'Thêm người dùng', 
        'userAdded': 'Người dùng đã được thêm', 
        'userEdit': 'Chỉnh sửa người dùng', 
        'editSuccess': 'Chỉnh sửa thành công', 
        'name-placeholder': 'Tên thật', 
        'loginName-placeholder': 'Tên đăng nhập', 
        'companyName': 'Tên nhà cung cấp', 
        'officeName': 'Tên văn phòng', 
        'mobile-placeholder': 'Số điện thoại di động', 
        'operate': 'Thao tác', 
        'edit': 'Chỉnh sửa', 
        'delete': 'Xóa', 
        'warnInfo1': 'Bạn có chắc chắn muốn xóa người dùng này?', 
        'current-account-no': 'Tài khoản hiện tại của bạn', 
        'modifier': 'Chỉnh sửa', 
        'login-password': 'Mật khẩu đăng nhập', 
        'login-password-tip': 'Để bảo vệ an toàn của tài khoản, bạn nên thay đổi mật khẩu thường xuyên', 
        'personal-data': 'Thông tin cá nhân', 
        'update-timely': 'Nếu thông tin cá nhân của bạn thay đổi, hãy cập nhật ngay', 
        'old-password': 'Mật khẩu cũ', 
        'new-password': 'Mật khẩu mới', 
        'confirm-new-password': 'Xác nhận mật khẩu mới', 
        'user-tip': 'Mã nhóm mặc định của người dùng bị sai, vui lòng chọn lại' 
 
 
    }, 
    'shared': { 
        'all': 'Tất cả', 
        'loading': 'Đang tải...', 
        'yes': 'Có', 
        'no': 'Không', 
        'page-total-count': 'Tổng số {{totalNum}} mục, ', 
        'page-total-pages': 'Tổng số {{totalPage}} trang, ', 
        'page-goto': 'Đến', 
        'page': 'Trang', 
        'page-previous': 'Trang trước', 
        'page-first': 'Trang đầu', 
        'page-next': 'Trang sau', 
        'page-last': 'Trang cuối', 
        'page-each': 'Mỗi trang', 
        'page-each-count': 'mục, ', 
        'table-colName': 'Cấu hình trường', 
        'table-sort': 'Thứ tự hiển thị', 
        'table-width': 'Độ rộng cột hiển thị', 
        'table-orderField': 'Sắp xếp truy vấn', 
        'table-orderType': 'Sắp xếp tăng/giảm dần', 
        'table-not-surported': 'Chức năng sắp xếp tạm thời không được hỗ trợ' 
    },
    'home': { 
        'common': { 
            'anounce-list': 'Danh sách thông báo', 
            'anounce-detail': 'Chi tiết thông báo', 
            'message-list': 'Danh sách tin nhắn', 
            'welcome': 'Chào mừng đến với nền tảng nhà cung cấp đám mây', 
            'supplier': 'Nhà cung cấp đám mây', 
            'ent': 'Tập đoàn：', 
            'title-home': 'Trang chủ', 
            'title-login': 'Đăng nhập', 
            'title-register': 'Đăng ký', 
            'title-anounce': 'Thông báo', 
            'title-anounce-detail': 'Toàn văn', 
            'title-message': 'Tin nhắn của tôi', 
            'find-psd': 'Tìm lại mật khẩu', 
            'today-order': 'Đơn hàng ngày hôm nay', 
            'unconfirmed-order': 'Đơn hàng chưa được xác nhận', 
            'overdue-order': 'Đơn hàng chưa giao hàng quá hạn', 
            'order-transit': 'Đơn hàng đang vận chuyển', 
            'get-code': 'Nhận mã xác minh', 
            'confirm-modification': 'Xác nhận sửa đổi' 
        }, 
        'login': { 
            'select-language': 'Chọn ngôn ngữ', 
            'please-fill-userid': 'Vui lòng điền tài khoản', 
            'please-fill-password': 'Vui lòng điền mật khẩu', 
            'user-placeholder': 'Tên đăng nhập', 
            'password-placeholder': 'Mật khẩu', 
            'login': 'Đăng nhập', 
            'login-now': 'Đăng nhập ngay', 
            'logout': 'Đăng xuất', 
            'platform': 'Nền tảng hợp tác giao hàng đám mây', 
            'zhilink-home': 'Trang chủ Zhilink', 
            'zhilink-copyright': 'Hỗ trợ kỹ thuật:©{{year}} Công ty TNHH công nghệ Zhilink (Thâm Quyến)', 
            'owner-website': 'Trang web chính thức', 
            'owner-copyright': '©Bản quyền {{year}}', 
            'owner-copyright2': 'Bản quyền thuộc về', 
            'owner-phone': 'Điện thoại liên hệ:', 
            'owner-mail': 'Email liên hệ:' 
        }, 
        'register': { 
            'form-title': 'Thông tin đăng ký nhà cung cấp', 
            'success': 'Thông tin đã được gửi thành công, vui lòng đợi xét duyệt và kiểm tra email trong thời gian gần nhất!' 
        }, 
        'notfound': { 
            'not-found-page': 'Lỗi, trang bạn truy cập không tìm thấy!', 
            'redirect-after-seconds': 'Tự động chuyển hướng sau {{count}} giây...', 
            'redirect-imediately': 'Chuyển hướng ngay' 
        }, 
        'anounce': { 
            'title': 'Tiêu đề', 
            'date': 'Ngày', 
            'more': 'Xem thêm', 
            'no-more-data': 'Không còn thông báo nào nữa' 
        }, 
        'message': { 
            'title': 'Tiêu đề', 
            'please-select-category': 'Vui lòng chọn loại tin nhắn:', 
            'all': 'Tất cả', 
            'read': 'Đã đọc', 
            'unread': 'Chưa đọc', 
            'mark-as-read': 'Đánh dấu tất cả là đã đọc' 
        } 
    },
    'other': {
        '温馨提示': 'Gợi ý ấm ',
        '收货仓库': 'Kho nhận hàng',
        '仓库储位': 'Kho chứa',
        '已结案订单明细': 'Chi tiết đơn đặt hàng đã kết thúc',
        '有答交日期在今天之前，': 'Có ngày trả lời trước hôm nay，',
        '交总数量小于产品数量，': 'Tổng số lượng giao hàng nhỏ hơn số lượng sản phẩm，',
        '您确定要保存吗？': 'Bạn có chắc là muốn lưu không？'
    }
};



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/i18n/vi.ts